module.exports = __webpack_public_path__ + "static/media/arrow.ab065115.svg";